import type { ProductOption } from "../ProductOption.js";
import type { ProductOptions } from "../ProductOptions.js";
import { ProductSize } from "../ProductSize.js";
import { productSizeKeyMap } from "../productSizeKeyMap.js";
import { restrictedProductOptions } from "../restrictedProductOptions.js";

export function doesProductHaveOption(enabledOptions: ProductOptions, option: ProductOption): boolean {
	return Object.values(ProductSize).some((size: ProductSize) => {
		const options = enabledOptions[productSizeKeyMap[size]];
		options.push(...restrictedProductOptions);
		return options.includes(option);
	});
}
